import { Modal } from "@/components/elements/Modal";
import { FCC } from "@/types/common";
import { Box, Stack, Typography, Link } from "@mui/material";
import { TGetTalentExistsDto } from "@/api/services/main/talent/dtos/get-talent-exists.dto";
import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { secondary, text } from "@/theme/colors";
import { useParams } from "react-router-dom";

type TDuplicateTalentModalProps = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  duplicateTalents: TGetTalentExistsDto[];
};

export const DuplicateTalentModal: FCC<TDuplicateTalentModalProps> = ({ open, onClose, onSave, duplicateTalents }) => {
  const handleTalentClick = (talentId: string) => {
    const detailRoute = getDynamicRoute(AppRoutes.talentDetail, { talentId });
    window.open(detailRoute, "_blank");
  };

  const { talentId } = useParams();

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      onOk={onSave}
      labelClose="キャンセル"
      labelOk={talentId ? "保存" : "新規で登録する"}
      width={500}
      enableFooter={true}
    >
      <Box mb={2}>
        <Typography variant="body1" sx={{ mb: 2, mt: 1 }}>
          氏名が同一の外国人がすでに登録されています。重複がないかご確認ください。
        </Typography>
        <Stack
          spacing={1.5}
          sx={{
            maxHeight: "500px",
            overflow: "auto",
          }}
        >
          {duplicateTalents.map((talent) => (
            <Box
              key={talent.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: text.primary,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                ・
              </Typography>
              <Link
                component="button"
                variant="body1"
                onClick={() => handleTalentClick(String(talent.id))}
                sx={{
                  textDecoration: "none",
                  color: secondary[80],
                  cursor: "pointer",
                  textAlign: "left",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  display: "inline-block",
                  width: "90%",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {talent.fullName}
              </Link>
            </Box>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};
